export const yhcDeliveryAreaNamesByFlg = (deliveryAreaFlag: string): string => {
  switch (deliveryAreaFlag) {
    case '0':
      return 'ヤマト運輸'
    case '1':
      return 'アートセッティングデリバリー'
    case '2':
      return 'ヤマト運輸'
    case '3':
      return '対応不可'
    default:
      return '不明'
  }
}
